import Vue from "vue"
import settings from "@/settings.coffee"


escape_double_quotes = (string)->
    if string != null
        string = string.replace(/"/g, '\\"')
    else
        string = ""
    return string

replace_newline_char = (obj)->
    # console.log "REPLACE : ", typeof(obj)
    # console.log "REPLACE : ", obj
    if typeof(obj) == 'string'
        obj = obj.replace(/\r\n|\n/g, "\\n")
    else if typeof(obj) == 'object'
        for k, v of obj
            # console.log "OBJECT", typeof(v)
            if typeof(v) == 'string'
                obj[k] = v.replace(/\r\n|\n/g, "\\n")
                # console.log "STRING", v
    # console.log "OBJ", obj
    return obj

delete_object = (model_name_lower, object_uid)->
    return """mutation{
    #{model_name_lower}_deletion(
        uid: \"#{object_uid}\"
    ){
        ok
        message
    }}"""

delete_vp_custom_vp_dated = (vpc_vpd_uid)->
    return """mutation{
    vp_custom_vp_dated_deletion(
        uid: \"#{vpc_vpd_uid}\"
    ){
        ok
        message
    }}"""

pass_vp_dated_user_job = (vpduj_uid_set)->
    return """mutation{
    pass_vp_dated_user_job_mutation(
        vp_dated_user_job_uid_set: #{JSON.stringify(vpduj_uid_set)}
    ){
        ok
        message
    }}"""

save_vp_custom_type_code = (vpc_set, company_uid)->
    ret = '['
    for item in vpc_set
        ret += '{'
        for k, v of item
            console.log "FOR VALUE ", typeof(v)
            if typeof(v) == 'string'
                ret += k+':'+'"'+v+'",'
        ret = ret.slice(0, -1)
        ret += '},'
    if vpc_set.length > 0
        ret = ret.slice(0, -1)
    ret += ']'

    console.log "RET : ", ret

    return """mutation{
    vp_custom_type_code_mutation(
        vp_custom_set: #{ret}
        company_uid: \"#{company_uid}\"
    ){
      ok
      message  
    }}"""

save_vp_dated_user_job = (duj, component)->
    clean_reason = replace_newline_char(duj.reason)
    # console.log "SAVE_VP_DATED_USER_JOB", duj
    return """mutation{
    vp_dated_user_job_form_mutation(input:{
        uid: \"#{duj.uid}\"
        state_uid: \"#{duj.state.uid}\"
        transmission_date: \"#{duj.transmission_date}\"
        file_url: \"#{duj.file_url}\"
        file_data: \"#{duj.file_data}\"
        file_name: \"#{duj.file_name}\"
        reason: \"#{escape_double_quotes(clean_reason)}\"
        component: \"#{component}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_element_set = (element_set, deletions, vpc_vpd_uid, user_job_uid, component)->
    ret = '['
    for item in element_set
        ret += '{'
        for k, v of item
            # console.log "FOR VALUE ", typeof(v)
            if k == "file_tmp_uid"
                continue
            if typeof(v) == 'number'
                ret += k+':'+v+','
            else if typeof(v) == 'string'
                ret += k+':'+'"'+v+'",'
        ret = ret.slice(0, -1)
        ret += '},'
    if element_set.length > 0
        ret = ret.slice(0, -1)
    ret += ']'

    # console.log "RET : ", ret

    return """mutation{
    vp_element_set_mutation(
        element_set: #{ret}
        vp_custom_vp_dated_uid: \"#{vpc_vpd_uid}\"
        user_job_uid: \"#{user_job_uid}\"
        deletions: #{JSON.stringify(deletions)}
        component: \"#{component}\"
    ){
        ok
        message
    }}"""

save_vpc_set = (vpc_set)->
    ret = '['
    for item in vpc_set
        ret += '{'
        for k, v of item
            # console.log "FOR VALUE ", typeof(v)
            if typeof(v) == 'boolean'
                ret += k+':'+v+','
            else if typeof(v) == 'string'
                ret += k+':'+'"'+v+'",'
        ret = ret.slice(0, -1)
        ret += '},'
    ret = ret.slice(0, -1)
    ret += ']'

    # console.log "RET : ", ret

    return """mutation{
    variable_payroll_custom_set_mutation(
        vpc_set: #{ret}
    ){
        ok
        message
    }}"""

save_vp_custom_vp_dated = (vpc_uid, date)->
    # console.log "SAVE VP_CUSTOM_VP_DATED", vpc_uid, date
    return """mutation{
    vp_custom_vp_dated_form_mutation(input:{
        vpc_uid: \"#{vpc_uid}\"
        date: \"#{date}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_variable_payroll_custom = (company_uid, date, col)->
    # console.log "SAVE variable_payroll_custom", company_uid, date, col
    return """mutation{
    variable_payroll_custom_form_mutation(input:{
        company_uid: \"#{company_uid}\"
        date: \"#{date}\"
        uid: \"#{col.uid}\"
        name: \"#{col.name}\"
        editable_by_all: #{col.editable_by_all}
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_variable_payroll_params = (params)->
    # console.log "SAVE variable_payroll_params", params
    return """mutation{
    variable_payroll_params_form_mutation(input:{
        uid: \"#{params.uid}\"
        company_uid: \"#{params.company_uid}\"
        max_date_delta: \"#{params.max_date_delta}\"
        sending_day: #{params.sending_day}
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_accounting_software_company_link = (as_link)->
    # console.log "SAVE accounting_software_company_link", as_link
    clean_comment = replace_newline_char(as_link.comment)
    return """mutation{
    accounting_software_company_link_form_mutation(input:{
        uid: \"#{as_link.uid}\"
        company_uid: \"#{as_link.company_uid}\"
        intermediary: \"#{escape_double_quotes(as_link.intermediary)}\"
        comment: \"#{escape_double_quotes(clean_comment)}\"
        api_url: \"#{as_link.api_url}\"
        api_client_login: \"#{as_link.api_client_login}\"
        api_client_pw: \"#{as_link.api_client_pw}\"
        api_user_login: \"#{as_link.api_user_login}\"
        api_user_pw: \"#{as_link.api_user_pw}\"
        accounting_software_uid: \"#{as_link.accounting_software.uid}\"
        axis: \"#{as_link.axis}\"
        user_connection: #{as_link.user_connection}
        automatic_item_uid_set: \"#{escape_double_quotes(JSON.stringify(as_link.automatic_item_uid_set))}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_balance = (balance)->
    # console.log "SAVE balance", balance
    return """mutation{
    balance_form_mutation(input:{
        uid: \"#{balance.uid}\"
        user_uid: \"#{balance.user_uid}\"
        leave_n_1_acquired: #{balance.leave_n_1.acquired}
        leave_n_1_taken: #{balance.leave_n_1.taken}
        leave_n_acquired: #{balance.leave_n.acquired}
        leave_n_taken: #{balance.leave_n.taken}
        seniority_leave_acquired: #{balance.seniority_leave.acquired}
        seniority_leave_taken: #{balance.seniority_leave.taken}
        extra_leave_1_acquired: #{balance.extra_leave_1.acquired}
        extra_leave_1_taken: #{balance.extra_leave_1.taken}
        extra_leave_2_acquired: #{balance.extra_leave_2.acquired}
        extra_leave_2_taken: #{balance.extra_leave_2.taken}
        rco_acquired: #{balance.rco.acquired}
        rco_taken: #{balance.rco.taken}
        rcr_acquired: #{balance.rcr.acquired}
        rcr_taken: #{balance.rcr.taken}
        rtt_acquired: #{balance.rtt.acquired}
        rtt_taken: #{balance.rtt.taken}
        cet_acquired: #{balance.cet.acquired}
        cet_taken: #{balance.cet.taken}
        break_acquired: #{balance.break_days.acquired}
        break_taken: #{balance.break_days.taken}
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_folder = (folder)->
    return """mutation{
    folder_form_mutation(input:{
        uid: \"#{folder.uid}\"
        parent_uid: \"#{folder.parent_uid}\"
        user_uid: \"#{folder.user_uid}\"
        name: \"#{escape_double_quotes(folder.name)}\"
        private: #{folder.private}
    }){
        errors{
            field
            messages
        }
        form_ret
    }}""" 

save_file = (file)->
    return """mutation{
    file_form_mutation(input:{
        uid: \"#{file.uid}\"
        folder_uid: \"#{file.folder_uid}\"
        user_uid: \"#{file.user_uid}\"
        name: \"#{escape_double_quotes(file.name)}\"
        private: #{file.private}
        filesize: #{file.file_size}
        filetype: \"#{file.file_type}\"
        file_name: \"#{file.file_name}\"
        file_data: \"#{file.file_data}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}""" 

save_import_configuration = (import_configuration)->
    return """mutation{
    import_configuration_form_mutation(input:{
        company_uid: \"#{import_configuration.company_uid}\"
        name: \"#{escape_double_quotes(import_configuration.name)}\"
        item: \"#{import_configuration.item}\"
        ignore_lines: #{import_configuration.ignore_lines}
        fields: \"#{import_configuration.fields}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_import = (import_data)->
    return """mutation{
    import_form_mutation(input:{
        uid: \"#{import_data.uid}\"
        company_uid: \"#{import_data.company_uid}\"
        csv_data: \"#{import_data.csv_data}\"
        csv_name: \"#{import_data.csv_name}\"
        item: \"#{import_data.item}\"
        delete_all: #{import_data.delete_all}
        is_utf8: #{import_data.is_utf8}
        separator: \"#{import_data.separator}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""    

save_event = (event_item)->
    return """mutation{
    event_form_mutation(input:{
        uid: \"#{event_item.uid}\"
        user_uid: \"#{event_item.user_uid}\"
        name: \"#{escape_double_quotes(event_item.name)}\"
        start: \"#{event_item.start}\"
        end: \"#{event_item.end}\"
        all_day: #{event_item.allday}
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_election = (election)->
    return """mutation{
    election_form_mutation(input:{
        uid: \"#{election.uid}\"
        company_uid: \"#{election.company_uid}\"
        employees: #{election.employees}
        done: #{election.done}
        last_election: \"#{election.last_election}\"
        next_election: \"#{election.next_election}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_user_skill = (user_skill)->
    return """mutation{
    user_skill_form_mutation(input:{
        uid: \"#{user_skill.uid}\"
        user_uid: \"#{user_skill.user_uid}\"
        skill_uid: \"#{user_skill.skill_uid}\"
        level: #{user_skill.level}
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

delete_user_custom_skill = (object_uid)->
    return """mutation{
    user_custom_skill_deletion(
        uid: \"#{object_uid}\"
    ){
        ok
        message
    }}"""

save_custom_skill = (custom_skill)->
    return """mutation{
    user_custom_skill_form_mutation(input:{
        user_uid: \"#{custom_skill.user_uid}\"
        skill_uid_or_new: \"#{custom_skill.skill_uid_or_new}\"
        eval:\"#{custom_skill.eval_uid}\"
        minimal_level_waited:#{custom_skill.minimal_level_waited}
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_campaign = (campaign, selected_user_uid)->
    return """mutation{
    interview_campaign_form_mutation(input:{
        uid: \"#{campaign.uid}\"
        user_uid: \"#{selected_user_uid}\"
        name: \"#{escape_double_quotes(campaign.name)}\"
        start: \"#{campaign.start}\"
        end: \"#{campaign.end}\"
        user_doc_data: \"#{campaign.user_doc_data}\"
        user_doc_name: \"#{campaign.user_doc_name}\"
        user_doc: \"#{campaign.user_doc}\"
        user_doc_dir: \"#{campaign.user_doc_dir}\"
        manager_doc_data: \"#{campaign.manager_doc_data}\"
        manager_doc_name: \"#{campaign.manager_doc_name}\"
        manager_doc: \"#{campaign.manager_doc}\"
        manager_doc_dir: \"#{campaign.manager_doc_dir}\"
        manager_final_doc_data: \"#{campaign.manager_final_doc_data}\"
        manager_final_doc_name: \"#{campaign.manager_final_doc_name}\"
        manager_final_doc: \"#{campaign.manager_final_doc}\"
        manager_final_doc_dir: \"#{campaign.manager_final_doc_dir}\"
        campaign_type: \"#{campaign.campaign_type}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_interview_file = (file)->
    return """mutation{
    interview_file_form_mutation(input:{
        uid: \"#{file.uid}\"
        interview_uid: \"#{file.interview_uid}\"
        name: \"#{escape_double_quotes(file.name)}\"
        filename_data: \"#{file.filename_data}\"
        filename_name: \"#{file.filename_name}\"
        filesize: #{file.filesize}
        filetype: \"#{file.filetype}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_interview = (interview, component)->
    clean_reason = replace_newline_char(interview.reason)
    return """mutation{
    interview_form_mutation(input:{
        uid: \"#{interview.uid}\"
        asked_user_uid: \"#{interview.asked_user_uid}\"
        interview_type_uid: \"#{interview.interview_type.uid}\"
        datetime: \"#{interview.datetime}\"
        state_uid: \"#{interview.state.uid}\"
        reason: \"#{escape_double_quotes(clean_reason)}\"
        component: \"#{component}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_pro_hazard = (pro_hazard)->
    return """mutation{
    pro_hazard_form_mutation(input:{
        company_uid: \"#{pro_hazard.company_uid}\"
        file_name: \"#{pro_hazard.file_name}\"
        uid: \"#{pro_hazard.uid}\"
        date: \"#{pro_hazard.date}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_formation = (formation, component)->
    clean_reason = replace_newline_char(formation.reason)
    return """mutation{
    formation_form_mutation(input:{
        uid: \"#{formation.uid}\"
        user_in_charge_uid: \"#{formation.user_in_charge_uid}\"
        formation_type_uid: \"#{formation.formation_type.uid}\"
        start: \"#{formation.start}\"
        end: \"#{formation.end}\"
        state_uid: \"#{formation.state.uid}\"
        reason: \"#{escape_double_quotes(clean_reason)}\"
        program_name: \"#{formation.program_name}\"
        program_data: \"#{formation.program_data}\"
        program: \"#{formation.program}\"
        program_dir: \"#{formation.program_dir}\"
        name: \"#{escape_double_quotes(formation.name)}\"
        location: \"#{escape_double_quotes(formation.location)}\"
        organization: \"#{escape_double_quotes(formation.organization)}\"
        duration: #{formation.duration}
        duration_unity: \"#{formation.duration_unity}\"
        funding_uid: \"#{formation.funding.uid}\"
        component: \"#{component}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_oncall_duty = (oncall_duty)->
    return """mutation{
    oncall_duty_form_mutation(input:{
        file_data: \"#{oncall_duty.file_data}\"
        file_name: \"#{oncall_duty.file_name}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_absence = (absence, component)->
    clean_reason = replace_newline_char(absence.reason)
    return """mutation{
    absence_form_mutation(input:{
        uid: \"#{absence.uid}\"
        user_in_charge_uid: \"#{absence.user_in_charge_uid}\"
        absence_type_uid: \"#{absence.absence_type.uid}\"
        start: \"#{absence.start}\"
        start_day_part: \"#{absence.start_day_part}\"
        end: \"#{absence.end}\"
        end_day_part: \"#{absence.end_day_part}\"
        nb_days: #{absence.nb_days}
        state_uid: \"#{absence.state.uid}\"
        reason: \"#{escape_double_quotes(clean_reason)}\"
        component: \"#{component}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_graduate = (graduate)->
    return """mutation{
    graduate_form_mutation(input:{
        uid: \"#{graduate.uid}\"
        user_uid: \"#{graduate.user_uid}\"
        name: \"#{escape_double_quotes(graduate.name)}\"
        validated: #{graduate.validated}
        obtainment: \"#{graduate.obtainment_str}\"
        validity_duration: \"#{graduate.validity_duration}\"
        validity_end: \"#{graduate.validity_end}\"
        level_uid: \"#{graduate.level.uid}\"
        graduate_type_uid: \"#{graduate.graduate_type.uid}\"
        file_name: \"#{graduate.file_name}\"
        file_data: \"#{graduate.file_data}\"
        file: \"#{graduate.file}\"
        file_dir: \"#{graduate.file_dir}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_payslip = (payslip)->
    return """mutation{
    pay_slip_form_mutation(input:{
        uid: \"#{payslip.uid}\"
        user_uid: \"#{payslip.user_uid}\"
        date: \"#{payslip.date}\"
        file_data: \"#{payslip.file_data}\"
        file_name: \"#{payslip.file_name}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_salary = (salary)->
    return """mutation{
    user_salary_form_mutation(input:{
        uid: \"#{salary.uid}\"
        user_uid: \"#{salary.user_uid}\"
        bonus: #{salary.bonus}
        base: #{salary.base}
        period: \"#{salary.period}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_voucher = (voucher)->
    return """mutation{
    user_voucher_form_mutation(input:{
        uid: \"#{voucher.uid}\"
        user_uid: \"#{voucher.user_uid}\"
        name: \"#{escape_double_quotes(voucher.name)}\"
        file_data: \"#{voucher.file_data}\"
        file_name: \"#{voucher.file_name}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_userjob = (userjob)->
    cleaned_employer_address = replace_newline_char(userjob.employer_address)
    # step: \"#{userjob.step}\"
    # coefficient: #{userjob.coefficient}
    return """mutation{
    user_job_form_mutation(input:{
        uid: \"#{userjob.uid}\"
        user_uid: \"#{userjob.user_uid}\"
        service_name: \"#{escape_double_quotes(userjob.service_name)}\"
        employer_name: \"#{escape_double_quotes(userjob.employer_name)}\"
        employer_address: \"#{escape_double_quotes(cleaned_employer_address)}\"
        organization_name: \"#{escape_double_quotes(userjob.organization_name)}\"
        tutor_name: \"#{escape_double_quotes(userjob.tutor_name)}\"
        idcc: \"#{escape_double_quotes(userjob.idcc)}\"
        reference: \"#{escape_double_quotes(userjob.reference)}\"
        file_data: \"#{userjob.file_data}\"
        file_name: \"#{userjob.file_name}\"
        file: \"#{userjob.file}\"
        file_dir: \"#{userjob.file_dir}\"
        level_uid: \"#{userjob.level.uid}\"
        contract_type_uid: \"#{userjob.contract_type.uid}\"
        status_uid: \"#{userjob.status.uid}\"
        weekly_hours: #{userjob.weekly_hours}
        partial_time: #{userjob.partial_time}
        notice_duration_unity: \"#{userjob.notice_duration_unity}\"
        trial_duration_unity: \"#{userjob.trial_duration_unity}\"
        notice_duration: #{userjob.notice_duration}
        trial_duration: #{userjob.trial_duration}
        renew_trial: #{userjob.renew_trial}
        start: \"#{userjob.start}\"
        end: \"#{userjob.end}\"
        establishments: \"#{userjob.establishments}\"
        job_uid_or_new: \"#{userjob.job_uid_or_new}\"
        interviews: \"#{userjob.interviews}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

# delete_object = (object_id, asked_access_labels, app_name, model_name, file_field)->
#     return """mutation{
#     object_deletion(
#         id: #{object_id}
#         asked_access_labels:\"#{asked_access_labels}\"
#         app_name:\"#{app_name}\"
#         model_name:\"#{model_name}\"
#         file_field:#{JSON.stringify(file_field)}
#     ){
#         ok
#         message
#     }}"""

save_recruitment = (recruitment)->
    # console.log "SAVE RECRUITMENT", recruitment
    clean_content = replace_newline_char(recruitment.content)
    # console.log "recruitment content", clean_content
    return """mutation{
    recruitment_form_mutation(input:{
        uid: \"#{recruitment.uid}\"
        job_uid: \"#{recruitment.job_uid}\"
        content: \"#{escape_double_quotes(clean_content)}\"
        experience_level_uid: \"#{recruitment.experience_level.uid}\"
        experience_mandatory: \"#{recruitment.experience_mandatory}\"
        experience_domains: \"#{escape_double_quotes(recruitment.experience_domains)}\"
        graduate_level_uid: \"#{recruitment.graduate_level.uid}\"
        graduate_mandatory: \"#{recruitment.graduate_mandatory}\"
        graduate_domains: \"#{escape_double_quotes(recruitment.graduate_domains)}\"
        pay_from: \"#{escape_double_quotes(recruitment.pay_from)}\"
        pay_to: \"#{escape_double_quotes(recruitment.pay_to)}\"
        bonus: \"#{escape_double_quotes(recruitment.bonus)}\"
        advantages: \"#{escape_double_quotes(recruitment.advantages)}\"
        employee_status_uid: \"#{recruitment.status.uid}\"
        context: \"#{escape_double_quotes(recruitment.context)}\"
        days_variable: \"#{recruitment.days_variable}\"
        hours_variable: \"#{recruitment.hours_variable}\"
        location: \"#{escape_double_quotes(recruitment.location)}\"
        trips_frequency: \"#{recruitment.trips_frequency}\"
        trips_zone: \"#{recruitment.trips_zone}\"
        active: \"#{recruitment.active}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_establishment = (establishment)->
    # console.log "SAVE ESTABLISHMENT", establishment
    return """mutation{
    establishment_form_mutation(input:{
        uid: \"#{establishment.uid}\"
        company_uid: \"#{establishment.company_uid}\"
        name:\"#{escape_double_quotes(establishment.name)}\"
        siret:\"#{escape_double_quotes(establishment.siret)}\"
        address:\"#{escape_double_quotes(establishment.address)}\"
        address2:\"#{escape_double_quotes(establishment.address2)}\"
        zipcode:\"#{escape_double_quotes(establishment.zipcode)}\"
        city:\"#{escape_double_quotes(establishment.city)}\"
        phone:\"#{escape_double_quotes(establishment.phone)}\"
        email:\"#{escape_double_quotes(establishment.email)}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

save_skills = (skills, job_uid, deletions)->
    # console.log "SAVE SKILLS", JSON.stringify(deletions)
    ret = '['
    for s in skills
        ret += '{'
        for k, v of s
            # console.log "FOR VALUE ", typeof(v)
            ret += k+':'
            if typeof(v) in ['number', 'boolean']
                ret += v+","
            else if typeof(v) == 'string'
                if k == "mandatory"
                    ret += v+","
                else
                    ret += "\""+replace_newline_char(v)+'",'
            else if typeof(v) == 'object'
                ret += "["
                ok = false
                for ki, vi of v
                    ok = true
                    ret += "{"
                    for kii, vii of vi
                        # console.log "FOR OBJECT ", typeof(vii)
                        ret += kii+':'
                        if typeof(vii) in ['number', 'boolean']
                            ret += vii+','
                        else if typeof(vii) == 'string'
                            if kii == "mandatory"
                                ret += vii+","
                            else
                                ret += "\""+replace_newline_char(vii)+'",'
                    ret = ret.slice(0, -1)
                    ret += "},"
                if ok
                    ret = ret.slice(0, -1)
                ret += "],"
        ret = ret.slice(0, -1)
        ret += "},"
    ret = ret.slice(0, -1)
    ret += "]"

    # console.log "RET : ", ret

    return """mutation{
    skills_mutation(
        skills: #{ret}
        job_uid: \"#{job_uid}\"
        deletions: #{JSON.stringify(deletions)}
    ){
        ok
    }}"""

save_job = (job)->
    # console.log "SAVE JOB", job
    return """mutation{
    job_form_mutation(input:{
        uid: \"#{job.uid}\"
        company_uid: \"#{job.company_uid}\"
        name:\"#{escape_double_quotes(job.name)}\"
        definition:\"#{escape_double_quotes(job.definition)}\"
        graduate_level_uid: \"#{job.graduate_level.uid}\"
        graduate_mandatory: #{job.graduate_mandatory}
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

delete_job = (job_uid)->
    # console.log "DELETE JOB", job_uid
    return """mutation{
    job_deletion(
        uid: \"#{job_uid}\"
    ){
        ok
        message
    }}"""

duplicate_job = (job_uids, same_company, company_uid)->
    # console.log "DUPLICATE JOB", job_uids
    return """mutation{
    job_duplication(
        uid_set: #{JSON.stringify(job_uids)}
        same_company: #{same_company}
        company_uid: \"#{company_uid}\"
    ){
        ok
        message
    }}"""

save_company_role = (company_uid, role_uid, name, dirigeant_profile)->
    # console.log "SAVE COMPANY ROLE"
    return """mutation{
    role_form_mutation(input:{
        company_uid: \"#{company_uid}\"
        role_uid: \"#{role_uid}\"
        name: \"#{escape_double_quotes(name)}\"
        dirigeant_profile: #{dirigeant_profile}
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""

delete_role = (role_uid)->
    # console.log "DELETE ROLE"
    return """mutation{
    role_deletion(
        uid: \"#{role_uid}\"
    ){
        ok
        message
    }}"""

save_company = (company)->
    # console.log "SAVE COMPANY : ", company
    return """mutation{
  	company_form_mutation(input:{
        uid: \"#{company.uid}\"
        legal_form_uid:\"#{company.legal_form.uid}\"
        reference:\"#{escape_double_quotes(company.reference)}\"
        name:\"#{escape_double_quotes(company.name)}\"
        ape_naf_code:\"#{escape_double_quotes(company.ape_naf_code)}\"
        siret:\"#{escape_double_quotes(company.siret)}\"
        employees_nb:#{company.employees_nb}
        address:\"#{escape_double_quotes(company.address)}\"
        address2:\"#{escape_double_quotes(company.address2)}\"
        zipcode:\"#{escape_double_quotes(company.zipcode)}\"
        city:\"#{escape_double_quotes(company.city)}\"
        phone:\"#{escape_double_quotes(company.phone)}\"
        email:\"#{company.email}\"
        logo_data: \"#{company.logo_data}\"
        logo_name: \"#{company.logo_name}\"
        opco:\"#{escape_double_quotes(company.opco)}\"
        opco_member_number:\"#{escape_double_quotes(company.opco_member_number)}\"
        opco_address:\"#{escape_double_quotes(company.opco_address)}\"
        opco_address2:\"#{escape_double_quotes(company.opco_address2)}\"
        opco_zipcode:\"#{escape_double_quotes(company.opco_zipcode)}\"
        opco_city:\"#{escape_double_quotes(company.opco_city)}\"
        opco_link:\"#{escape_double_quotes(company.opco_link)}\"
        medical:\"#{escape_double_quotes(company.medical)}\"
        medical_member_number:\"#{escape_double_quotes(company.medical_member_number)}\"
        medical_address:\"#{escape_double_quotes(company.medical_address)}\"
        medical_address2:\"#{escape_double_quotes(company.medical_address2)}\"
        medical_zipcode:\"#{escape_double_quotes(company.medical_zipcode)}\"
        medical_city:\"#{escape_double_quotes(company.medical_city)}\"
        medical_link:\"#{escape_double_quotes(company.medical_link)}\"
        voluntary_contribution:#{company.voluntary_contribution}
        voluntary_contribution_amount:#{company.voluntary_contribution_amount}
        distribution_uid: \"#{company.distribution.uid}\"
        is_distributor: #{company.distribution.is_distributor}
        distributed_by_uid: \"#{company.distribution.distributed_by_uid}\"
        white_label: #{company.distribution.white_label}
        distribution_logo_data: \"#{company.distribution.distribution_logo_data}\"
        distribution_logo_name: \"#{company.distribution.distribution_logo_name}\"
        admin_email: \"#{company.distribution.admin_email}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""
save_contact_opco = (contact_opco)->
    # console.log "SAVE EVALUATION",contact_opco
    return """mutation{
  	contact_opco_form_mutation(input:{
        uid: \"#{contact_opco.uid}\"
        company: \"#{contact_opco.company_uid}\"
        firstname: \"#{contact_opco.firstname}\"
        lastname: \"#{contact_opco.lastname}\"
        phone: \"#{contact_opco.phone}\"
        email: \"#{contact_opco.email}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""
save_contact_medical = (contact_medical)->
    # console.log "SAVE EVALUATION",contact_medical
    return """mutation{
  	contact_medical_form_mutation(input:{
        uid: \"#{contact_medical.uid}\"
        company: \"#{contact_medical.company_uid}\"
        firstname: \"#{contact_medical.firstname}\"
        lastname: \"#{contact_medical.lastname}\"
        phone: \"#{contact_medical.phone}\"
        email: \"#{contact_medical.email}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""
save_app_user = (app_user, company_uid)->
    # console.log "SAVE APP USER : ", app_user
    # roles -> string of ids separated by /
    # dates -> "yyyy-MM-dd"
    return """mutation{
    app_user_form_mutation(input:{
        uid: \"#{app_user.uid}\"
        company_uid: \"#{company_uid}\"
        parent_uid: \"#{app_user.parent.uid}\"
        email: \"#{app_user.email}\"
        roles: \"#{app_user.roles}\"
        is_active: #{app_user.is_active}
        is_archived: #{app_user.is_archived}
        lastname: \"#{escape_double_quotes(app_user.user_info.lastname)}\"
        firstname: \"#{escape_double_quotes(app_user.user_info.firstname)}\"
        gender: #{app_user.user_info.gender}
        birthday: \"#{app_user.user_info.birthday}\"
        nationality: \"#{escape_double_quotes(app_user.user_info.nationality)}\"
        title_of_stay: #{app_user.user_info.title_of_stay}
        title_of_stay_name: \"#{escape_double_quotes(app_user.user_info.title_of_stay_name)}\"
        title_of_stay_number: \"#{escape_double_quotes(app_user.user_info.title_of_stay_number)}\"
        title_of_stay_validity: \"#{app_user.user_info.title_of_stay_validity}\"
        social_nbr: \"#{escape_double_quotes(app_user.user_info.social_nbr)}\"
        medical_visit: \"#{app_user.user_info.medical_visit}\"
        sir: #{app_user.user_info.sir}
        rqth: #{app_user.user_info.rqth}
        rqth_end: \"#{app_user.user_info.rqth_end}\"
        address: \"#{escape_double_quotes(app_user.user_info.address)}\"
        address2: \"#{escape_double_quotes(app_user.user_info.address2)}\"
        zipcode: \"#{escape_double_quotes(app_user.user_info.zipcode)}\"
        city: \"#{escape_double_quotes(app_user.user_info.city)}\"
        phone: \"#{escape_double_quotes(app_user.user_info.phone)}\"
        photo_data: \"#{app_user.user_info.photo_data}\"
        photo_name: \"#{app_user.user_info.photo_name}\"
        opco: \"#{escape_double_quotes(app_user.user_info.opco)}\"
        reference: \"#{escape_double_quotes(app_user.user_info.reference)}\"
      }){
      errors{
        field
        messages
      }
      form_ret
    }}"""


ret = ''
traverse = (object)->
    # console.log "RET ", ret
    ret += "["
    for key, o of object
        # console.log "FOR OBJECT ", key, o
        ret += "{"
        for k, v of o
            # console.log "FOR VALUE ", v
            if k in ['roles', 'fullname', 'establishments', 'is_active', 'is_activated', 'is_archived', 'user_info', 'editable', 'is_manager', 'level', 'position']
                continue
            ret += k+':'
            if k in ['uid', 'parent_uid', 'fullnamejobs']
                ret += "\""+v+'",'
            else
                # console.log "FINAL ELSE ", v
                traverse(v)
        if parseInt(key) == Object.keys(object).length-1
            ret += "}"
        else
            ret += "},"
    ret += "]"
    return ret

save_tree = (tree)->
    # console.log "SAVE TREE", tree
    ret = ''
    ret = traverse(tree)
    # console.log "TREE RET ", ret

    return """mutation{
    tree_mutation(
        app_users: #{ret}
    ){
        ok
        message
    }}"""

prepare_access_role_datas = (datas)->
    ret = '['
    all_rights_role_index = []
    for i, d of datas
        if i == '0'
            for j, ar of d.access_role_set
                ret += '{access_uid:"'+ar.access_uid+'",role_uid:"'+ar.role_uid+'",checked:'+ar.checked+'},'
                if ar.checked
                    all_rights_role_index.push(j)
        else
            if !d.group_line
                for k, ar of d.access_role_set
                    if k not in all_rights_role_index
                        ret += '{access_uid:"'+ar.access_uid+'",role_uid:"'+ar.role_uid+'",checked:'+ar.checked+'},'
    ret = ret.slice(0, -1)
    ret += "]"
    return ret

save_access_role_set = (access_role_set)->
    ret = prepare_access_role_datas(access_role_set)
    # console.log "SAVE ACCESS ROLE", ret
    return """mutation{
    access_role_mutation(
        access_role_set: #{ret}
    ){
        ok
        message
    }}"""

delete_app_user = (user_uid)->
    # console.log "DELETE USER", user_uid
    return """mutation{
    app_user_deletion(
        uid: \"#{user_uid}\"
    ){
        ok
        message
    }}"""

save_account = (user_uid, email, password, password_confirm)->
    # console.log "SAVE ACCOUNT"
    return """mutation{
    account_form_mutation(input:{
        app_user_uid: \"#{user_uid}\"
        email: \"#{email}\"
        password: \"#{escape_double_quotes(password)}\"
        password_confirm: \"#{escape_double_quotes(password_confirm)}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""
save_evalcomment = (evalcomment)->
    # console.log "SAVE EVALUATION COMMENT"
    return """mutation{
    evalcomment_form_mutation(input:{
        uid:\"#{evalcomment.uid}\"
        text:\"#{evalcomment.text}\"
        eval:\"#{evalcomment.eval}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""   

save_evaluation = (evaluation_form)->
    # console.log "SAVE EVALUATION"
    return """mutation{
    evaluation_form_mutation(input:{
        uid:\"#{evaluation_form.uid}\"
        finished:#{evaluation_form.finished}
        user_job:\"#{evaluation_form.user_job}\"
        evaluator:\"#{evaluation_form.evaluator}\"
        date:\"#{evaluation_form.date}\"
        name:\"#{evaluation_form.name}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""
save_annuairetypegroupe = (annuairetypegroupe_form)->
    console.log ("SAVE ANNUAIRETYPEGROUPE")
    return """mutation{
    annuairetypegroupe_form_mutation(input:{
        uid:\"#{annuairetypegroupe_form.uid}\"
        name:\"#{annuairetypegroupe_form.name}\"
        company_uid:\"#{annuairetypegroupe_form.company_uid}\"
        user_uid:\"#{annuairetypegroupe_form.user_uid}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""
save_annuairegroupe = (annuairegroupe_form)->
    console.log ("SAVE ANNUAIREGROUPE")
    return """mutation{
    annuairegroupe_form_mutation(input:{
        uid:\"#{annuairegroupe_form.uid}\"
        user:\"#{annuairegroupe_form.user_uid}\"
        type:\"#{annuairegroupe_form.type_uid}\"
    }){
        errors{
            field
            messages
        }
        form_ret
    }}"""         
run = (query_name, params)->
    self = @
    p = new Promise (resolve, reject)->
        if self[query_name]?
            q = self[query_name].apply(null, params)
            console.log "M : "+q
            Vue.http.post(settings.graphql_url, {query: q})
            .then (resp)->
                resolve(resp)
            .catch (resp)->
                reject(resp)
        else
            reject({body:{errors:[message:"Mutation "+query_name+" is not defined"]}})
    return p

export default {
    delete_app_user: delete_app_user
    delete_vp_custom_vp_dated: delete_vp_custom_vp_dated
    delete_job: delete_job
    delete_object: delete_object
    delete_role: delete_role
    delete_user_custom_skill: delete_user_custom_skill
    duplicate_job: duplicate_job
    pass_vp_dated_user_job: pass_vp_dated_user_job
    save_absence: save_absence
    save_access_role_set: save_access_role_set
    save_account: save_account
    save_accounting_software_company_link: save_accounting_software_company_link
    save_app_user: save_app_user
    save_balance: save_balance
    save_campaign: save_campaign
    save_company: save_company
    save_contact_opco: save_contact_opco
    save_contact_medical: save_contact_medical
    save_company_role: save_company_role
    save_custom_skill: save_custom_skill
    save_election: save_election
    save_element_set: save_element_set
    save_establishment: save_establishment
    save_event: save_event
    save_file: save_file
    save_folder: save_folder
    save_formation: save_formation
    save_graduate: save_graduate
    save_import: save_import
    save_import_configuration: save_import_configuration
    save_interview: save_interview
    save_interview_file: save_interview_file
    save_job: save_job
    save_oncall_duty: save_oncall_duty
    save_payslip: save_payslip
    save_pro_hazard: save_pro_hazard
    save_recruitment: save_recruitment
    save_salary: save_salary
    save_skills: save_skills
    save_tree: save_tree
    save_user_skill: save_user_skill
    save_userjob: save_userjob
    save_variable_payroll_custom: save_variable_payroll_custom
    save_variable_payroll_params: save_variable_payroll_params
    save_voucher: save_voucher
    save_vpc_set: save_vpc_set
    save_vp_custom_type_code: save_vp_custom_type_code
    save_vp_custom_vp_dated: save_vp_custom_vp_dated
    save_vp_dated_user_job: save_vp_dated_user_job
    save_evaluation: save_evaluation
    save_evalcomment: save_evalcomment
    save_annuairetypegroupe: save_annuairetypegroupe
    save_annuairegroupe: save_annuairegroupe
    run: run
}
